import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home/newHome'
import Poem from '@/pages/Poem/Poem'
import Rhesis from '@/pages/Rhesis/Rhesis'
import Kindle from '@/pages/Kindle/Kindle'
import Calendar from '@/pages/Calendar/Calendar'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'newHome',
      component: Home
    }, {
      path: '/poem',
      name: 'Poem',
      component: Poem
    }, {
      path: '/rhesis',
      name: 'Rhesis',
      component: Rhesis
    }, {
      path: '/kindle',
      name: 'Kindle',
      component: Kindle
    }, {
      path: '/calendar',
      name: Calendar,
      component: Calendar
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js